import api from '../../config/axios.js';

const state = {
    clientsList: [],
    currentDeleteClient: {},
    currentUpdateClient: {},
    currentUpdateClientTab: 'appointments',
    clientsRankingQtdAttendant: [],
    clientsRankingQtdAttendantPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 30,
        total: 0,
    },
    clientsRankingTotalValue: [],
    clientsRankingTotalValuePagination: {
        current_page: 1,
        last_page: 1,
        per_page: 30,
        total: 0,
    },
    clientsRankingLastAttendant: [],
    clientsRankingLastAttendantPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 30,
        total: 0,
    },
    clientsRankingTotalValueSold: [],
    clientsRankingTotalValueSoldPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 30,
        total: 0,
    },
    clientsRankingLastPurchase: [],
    clientsRankingLastPurchasePagination: {
        current_page: 1,
        last_page: 1,
        per_page: 30,
        total: 0,
    },
    clientsBirthdayMonth: [],
    clientsBirthdayMonthPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 30,
        total: 0,
    },
    clientsPagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
    },
}

const getters = {
    getClientsList: state => state.clientsList,
    getCurrentDeleteClient: state => state.currentDeleteClient,
    getCurrentUpdateClient: state => state.currentUpdateClient,
    getCurrentUpdateClientTab: state => state.currentUpdateClientTab,
    getClientsRankingQtdAttendant: state => state.clientsRankingQtdAttendant,
    getClientsRankingQtdAttendantPagination: state => state.clientsRankingQtdAttendantPagination,
    getClientsRankingTotalValue: state => state.clientsRankingTotalValue,
    getClientsRankingTotalValuePagination: state => state.clientsRankingTotalValuePagination,
    getClientsRankingLastAttendant: state => state.clientsRankingLastAttendant,
    getClientsRankingLastAttendantPagination: state => state.clientsRankingLastAttendantPagination,
    getClientsRankingTotalValueSold: state => state.clientsRankingTotalValueSold,
    getClientsRankingTotalValueSoldPagination: state => state.clientsRankingTotalValueSoldPagination,
    getClientsRankingLastPurchase: state => state.clientsRankingLastPurchase,
    getClientsRankingLastPurchasePagination: state => state.clientsRankingLastPurchasePagination,
    getClientsBirthdayMonth: state => state.clientsBirthdayMonth,
    getClientsBirthdayMonthPagination: state => state.clientsBirthdayMonthPagination,
    getClientsPagination: state => state.clientsPagination,
}

const actions = {
    // RANKING CLIENTES QTD ATENDIMENTOS
    async fetchClientsRankingQtdAttendant({ commit }, page = 1){
        await api.axios.get(`/api/clients/ranking/qtd?page=${page}`).catch(() => {
            commit("fetchClientsRankingQtdAttendant", []);
            commit("setClientsRankingQtdAttendantPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 30,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("fetchClientsRankingQtdAttendant", list);
                commit("setClientsRankingQtdAttendantPagination", pagination);
            }
        });
    },
    // RANKING CLIENTES VALOR TOTAL
    async fetchClientsRankingTotalValue({ commit }, page = 1){
        await api.axios.get(`/api/clients/ranking/value?page=${page}`).catch(() => {
            commit("fetchClientsRankingTotalValue", []);
            commit("setClientsRankingTotalValuePagination", {
                current_page: 1,
                last_page: 1,
                per_page: 30,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("fetchClientsRankingTotalValue", list);
                commit("setClientsRankingTotalValuePagination", pagination);
            }
        });
    },
    // RANKING CLIENTES VALOR TOTAL EM COMPRAS
    async fetchClientsRankingTotalValueSold({ commit }, page = 1){
        await api.axios.get(`/api/clients/ranking/value-sold?page=${page}`).catch(() => {
            commit("fetchClientsRankingTotalValueSold", []);
            commit("setClientsRankingTotalValueSoldPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 30,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("fetchClientsRankingTotalValueSold", list);
                commit("setClientsRankingTotalValueSoldPagination", pagination);
            }
        });
    },
    // RANKING CLIENTES ATENDIMENTOS MAIS ANTIGOS
    async fetchClientsRankingLastAttendant({ commit }, page = 1){
        await api.axios.get(`/api/clients/ranking/last-attendant?page=${page}`).catch(() => {
            commit("fetchClientsRankingLastAttendant", []);
            commit("setClientsRankingLastAttendantPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 30,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("fetchClientsRankingLastAttendant", list);
                commit("setClientsRankingLastAttendantPagination", pagination);
            }
        });
    },
    // RANKING CLIENTES COMPRAS MAIS ANTIGOS
    async fetchClientsRankingLastPurchase({ commit }, page = 1){
        await api.axios.get(`/api/clients/ranking/last-purchase?page=${page}`).catch(() => {
            commit("fetchClientsRankingLastPurchase", []);
            commit("setClientsRankingLastPurchasePagination", {
                current_page: 1,
                last_page: 1,
                per_page: 30,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("fetchClientsRankingLastPurchase", list);
                commit("setClientsRankingLastPurchasePagination", pagination);
            }
        });
    },
    // LISTANDO CLIENTES ANIVERSARIANTES DO MÊS
    async fetchClientsBirthdayMonth({ commit }, page = 1){
        await api.axios.get(`/api/clients/birthday-month?page=${page}`).catch(() => {
            commit("fetchClientsBirthdayMonth", []);
            commit("setClientsBirthdayMonthPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 30,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("fetchClientsBirthdayMonth", list);
                commit("setClientsBirthdayMonthPagination", pagination);
            }
        });
    },
    // LISTANDO CLIENTES
    async setClientsList({ commit }, page = 1){
        await api.axios.get(`/api/clients?page=${page}`).catch(() => {
            commit("setClientsList", []);
            commit("setClientsPagination", {
                current_page: 1,
                last_page: 1,
                per_page: 10,
                total: 0,
            });
        }).then((response) => {
            if(response && response.data){
                const payload = response.data;
                const list = Array.isArray(payload.data) ? payload.data : payload;
                const pagination = Array.isArray(payload.data)
                    ? {
                        current_page: payload.current_page || page,
                        last_page: payload.last_page || 1,
                        per_page: payload.per_page || list.length,
                        total: payload.total || list.length,
                    }
                    : {
                        current_page: 1,
                        last_page: 1,
                        per_page: list.length,
                        total: list.length,
                    };

                commit("setClientsList", list);
                commit("setClientsPagination", pagination);
            }
        });
    },
    async setCurrentDeleteClient({ commit }, data){
        commit('setCurrentDeleteClient', data);
    },
    async setCurrentUpdateClient({ commit }, data){
        commit('setCurrentUpdateClient', data);
    },
    async setCurrentUpdateClientTab({ commit }, tab){
        commit('setCurrentUpdateClientTab', tab || 'appointments');
    },
    // CRIAR CLIENTE
    async createClient({ commit }, obj){
        // Placeholder for create action if needed in store, 
        // though the modal usually handles it directly or via this action.
        // Replicating pattern if needed, but usually components call API directly in this project's style 
        // (based on CreateUserModal calling api.axios.post directly).
        // However, if we want to refresh the list after creation:
        // This might be called from the component.
    }
}

const mutations = {
    setClientsList: function(state, data){
        state.clientsList = data;
    },
    setCurrentDeleteClient: function(state, data){
        state.currentDeleteClient = data;
    },
    setCurrentUpdateClient: function(state, data){
        state.currentUpdateClient = data;
    },
    setCurrentUpdateClientTab: function(state, data){
        state.currentUpdateClientTab = data || 'appointments';
    },
    fetchClientsRankingQtdAttendant: function(state, data){
        state.clientsRankingQtdAttendant = data;
    },
    setClientsRankingQtdAttendantPagination: function(state, data){
        state.clientsRankingQtdAttendantPagination = data;
    },
    fetchClientsRankingTotalValue: function(state, data){
        state.clientsRankingTotalValue = data;
    },
    setClientsRankingTotalValuePagination: function(state, data){
        state.clientsRankingTotalValuePagination = data;
    },
    fetchClientsRankingTotalValueSold: function(state, data){
        state.clientsRankingTotalValueSold = data;
    },
    setClientsRankingTotalValueSoldPagination: function(state, data){
        state.clientsRankingTotalValueSoldPagination = data;
    },
    fetchClientsRankingLastAttendant: function(state, data){
        state.clientsRankingLastAttendant = data;
    },
    setClientsRankingLastAttendantPagination: function(state, data){
        state.clientsRankingLastAttendantPagination = data;
    },
    fetchClientsRankingLastPurchase: function(state, data){
        state.clientsRankingLastPurchase = data;
    },
    setClientsRankingLastPurchasePagination: function(state, data){
        state.clientsRankingLastPurchasePagination = data;
    },
    fetchClientsBirthdayMonth: function(state, data){
        state.clientsBirthdayMonth = data;
    },
    setClientsBirthdayMonthPagination: function(state, data){
        state.clientsBirthdayMonthPagination = data;
    },
    setClientsPagination: function(state, data){
        state.clientsPagination = data;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}
